import React, { useState, useEffect, forwardRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FaRegCalendarAlt } from 'react-icons/fa';
import {
  getCollegeList_Concat_API,
    get_user_colleges_API,
  get_department_info_Test_API_CC,
  get_Batches_API_CLG_ID,
  getrulesApi,
  getCollegeCodes,
  sendAssignTestData_API_superadmin,  // Use existing API function
} from '../../api/endpoints';
import CustomOption from './customoption';


const customStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: 'rgb(50, 59, 68)',
        color: '#fff', // Text color
       border: state.isFocused
      ? "1px solid rgb(85, 85, 85)"
      : "1px solid rgb(85, 85, 85)", // Same border always, you can change if needed
    boxShadow: "none", // Remove blue focus ring
    "&:hover": {
      border: "1px solid rgb(85, 85, 85)", // Border on hover
    },
        '&.css-1a1jibm-control': {
            // Additional styles for the specific class
        },
        '@media (max-width: 768px)': { // Adjust for mobile devices
            fontSize: '12px', // Smaller font size

            width: '70%'
        }
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#ffff', // Text color for selected value
        '@media (max-width: 768px)': { // Adjust for mobile devices
            fontSize: '12px' // Smaller font size
        }
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? 'rgb(50, 59, 68)' : state.isFocused ? 'rgb(50, 59, 68)' : 'rgb(50, 59, 68)',
        color: '#ffff', // Text color
        '&:hover': {
            backgroundColor: 'rgb(50, 59, 68)', // Background color on hover
            color: '#ffff' // Text color on hover
        },
        '@media (max-width: 768px)': { // Adjust for mobile devices
            fontSize: '12px',// Smaller font size
            width: '70%'
        }
    }),
    input: (provided) => ({
        ...provided,
        color: '#ffff' // Text color inside input when typing
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: 'rgb(50, 59, 68)',
        '@media (max-width: 768px)': { // Adjust for mobile devices
            fontSize: '12px' // Smaller font size
        }
    })

};

const fetchCollegeCode = async (collegeName) => {
  console.log('Fetching college code for:', collegeName);
  try {
    const res = await getCollegeCodes();
    const data = res.data;
    console.log('Received data from getCollegeCodes API:', data);

    if (Array.isArray(data)) {
      const found = data.find(
        c => c.college && c.college.trim().toLowerCase() === collegeName.trim().toLowerCase()
      );
      if (found) {
        console.log('Found college code:', found.college_code);
      } else {
        console.warn('No matching college found for:', collegeName);
      }
      return found ? found.college_code : '';
    } else {
      console.warn('API data is not in expected array format:', data);
    }
    return '';
  } catch (error) {
    console.error('Error fetching college codes:', error);
    return '';
  }
};

const yearOptions = [
  { value: 'all', label: 'All' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' }
];

function formatDateTime(dt) {
  if (!dt) return null;
  const pad = n => String(n).padStart(2, '0');
  return (
    dt.getFullYear() +
    '-' +
    pad(dt.getMonth() + 1) +
    '-' +
    pad(dt.getDate()) +
    'T' +
    pad(dt.getHours()) +
    ':' +
    pad(dt.getMinutes()) +
    ':' +
    pad(dt.getSeconds())
  );
}

const CalendarInput = forwardRef(({ value, onClick, placeholder }, ref) => (
  <div style={{ position: 'relative', width: '100%' }}>
    <input
      style={{
        width: '100%',
        background: '#323b44',
        color: 'white',
        border: '1px solid #555',
        borderRadius: '4px',
        padding: '5px 35px 5px 5px'
      }}
      onClick={onClick}
      ref={ref}
      value={value}
      readOnly
      placeholder={placeholder}
    />
    <FaRegCalendarAlt
      style={{
        position: 'absolute',
        right: 10,
        top: '50%',
        transform: 'translateY(-50%)',
        color: '#f1a128',
        pointerEvents: 'none'
      }}
      size={20}
    />
  </div>
));

const AddTestPage = ({institute,collegeName,username,userRole}) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
  
  
  console.log("new",institute,collegeName,username,userRole)
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location || {};

  const [collegeCodesMap, setCollegeCodesMap] = useState({});

  const [testFormData, setTestFormData] = useState({
    test_name: state?.testName || '',
    test_type: state?.test_type || '',
    skill_type: state?.sub_topic || '',
    question_type: state?.topic || '',
    folder_name: state?.folder_name || '',
    question_ids: state?.question_ids || [],
    is_testcase: state?.is_testcase || false,
    time: state?.time || '',
  });
  // console.log('Current testFormData:', testFormData);

  const [extraFields, setExtraFields] = useState({
    no_of_questions: '',
    duration: '',
    college: [],
    branch: [],
    department: [],
    year: [],
    rule: null,
    need_candidate_info: true,
    is_camera_on: false,
  });

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [collegeList, setCollegeList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [selectedYear, setSelectedYear] = useState([]);
  const [ruleList, setRuleList] = useState([]);
  const [isTestcase, setIsTestcase] = useState(false);

  const handleTestcaseChange = (e) => {
    setIsTestcase(e.target.checked);
  };

      // State to store college ID
  const [userColleges, setUserColleges] = useState([]); // store dropdown options
  
  useEffect(() => {
    if (!username) return;
  
    if (userRole === "Training admin") {
      // ✅ Case 1: Training admin → fetch only assigned colleges
      get_user_colleges_API(username)
        .then((userData) => {
          const collegeIds = userData.college_ids;
  
          return getCollegeList_Concat_API().then((collegeList) => {
            const matchedColleges = collegeList
              .filter((college) => collegeIds.includes(String(college.id)))
              .map((college) => ({
                value: college.id,
                label: college.college_group_concat,
              }));
  
            setUserColleges(matchedColleges);
          });
        })
        .catch((error) => {
          console.error("❌ Error fetching user colleges:", error);
        });
    } else {
      // ✅ Case 2: Other roles → show all colleges
      getCollegeList_Concat_API()
        .then((collegeList) => {
          const allColleges = collegeList.map((college) => ({
            value: college.id,
            label: college.college_group_concat,
          }));
          setUserColleges(allColleges);
        })
        .catch((error) => {
          console.error("❌ Error fetching all colleges:", error);
        });
    }
  }, [username, userRole]);
  
  

  useEffect(() => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 18, 0, 0, 0);
    const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 22, 0, 0, 0);
    setStartDate(start);
    setEndDate(end);
  }, []);

  useEffect(() => {
    if (startDate) {
      const newEnd = new Date(startDate.getTime() + 4 * 60 * 60 * 1000);
      if (!endDate || endDate <= startDate) {
        setEndDate(newEnd);
      }
    }
  }, [startDate]);

  useEffect(() => {
    getCollegeList_Concat_API()
      .then(data => {
        setCollegeList(data.map(c => ({
          value: c.id,
          label: c.college_group_concat
        })));
      })
      .catch(() => setCollegeList([]));
  }, []);
useEffect(() => {
  if (userRole === "Placement Officer" && institute && collegeName) {
    setExtraFields(fields => ({
      ...fields,
      college: [{
        value: institute,
        label: collegeName
      }]
    }));
  }
}, [userRole, institute, collegeName]);

  useEffect(() => {
    if (!extraFields.college.length) {
      setBranchList([]);
      setDepartmentList([]);
      setExtraFields(fields => ({ ...fields, branch: [], department: [] }));
      return;
    }
    const collegeIds = extraFields.college.map(clg => clg.value);
    get_Batches_API_CLG_ID(collegeIds)
      .then(batches => {
        const branches = batches.map(b => ({
          value: b.batch_no,
          label: b.batch_no
        }));
        setBranchList(branches);
        if (!branches.length) {
          setExtraFields(fields => ({ ...fields, branch: [] }));
        }
      })
      .catch(() => setBranchList([]));

    get_department_info_Test_API_CC(collegeIds)
      .then(depts => {
        const departmentOptions = depts.map(d => ({
          value: d.department_id__id,
          label: d.department_id__department
        }));

        setDepartmentList([{ value: 'all', label: 'All' }, ...departmentOptions]);
      })
      .catch(() => setDepartmentList([]));
  }, [extraFields.college]);

  useEffect(() => {
    getrulesApi()
      .then(data => {
        const rules = data.map(r => ({
          value: r.id,
          label: r.rule_name
        }));
        setRuleList(rules);

        if (testFormData.test_type) {
          const matchedRule = rules.find(rule =>
            rule.label.trim().toLowerCase() === testFormData.test_type.trim().toLowerCase()
          );
          setExtraFields(fields => ({ ...fields, rule: matchedRule || null }));
        }
      })
      .catch(() => setRuleList([]));
  }, [testFormData.test_type]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTestFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleExtraChange = (e) => {
    const { name, value, type, checked } = e.target;
    setExtraFields(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSelectChange = async (selected, actionMeta) => {
    if (actionMeta.name === "college" && selected && selected.length > 0) {
      setExtraFields(prev => ({
        ...prev,
        [actionMeta.name]: selected || []
      }));

      const collegeLabel = selected[0].label || selected[0].value;
      console.log('Selected College Name:', collegeLabel);
      let collegeCode = '';
      try {
        collegeCode = await fetchCollegeCode(collegeLabel);
        console.log('Selected College Code:', collegeCode);
      } catch {
        collegeCode = '';
      }
      setCollegeCodesMap((prev) => ({ ...prev, [collegeLabel]: collegeCode }));

      if ((state?.testName || testFormData.test_name) && startDate) {
        const day = String(startDate.getDate()).padStart(2, '0');
        const month = String(startDate.getMonth() + 1).padStart(2, '0');
        const datePart = `${day}${month}`;
        const originalTestName = state?.testName || testFormData.test_name;
        const newTestName = `${collegeCode}_${originalTestName}_${datePart}`;
        setTestFormData(prev => ({
          ...prev,
          test_name: newTestName
        }));
      }
    } else {
      setExtraFields(prev => ({
        ...prev,
        [actionMeta.name]: selected || []
      }));
    }
  };

  const handleDepartmentsChange = (selectedOptions) => {
    if (!selectedOptions) {
      setSelectedDepartments([]);
      return;
    }
    if (selectedOptions.some(option => option.value === 'all')) {
      setSelectedDepartments([{ value: 'all', label: 'All' }]);
    } else {
      setSelectedDepartments(selectedOptions);
    }
  };

  const handleYearChange = (selectedOptions) => {
    if (!selectedOptions) {
      setSelectedYear([]);
      return;
    }
    const selectedValues = selectedOptions.map(option => option.value);
    if (selectedValues.includes('all')) {
      setSelectedYear(yearOptions.filter(year => year.value !== 'all'));
    } else {
      setSelectedYear(selectedOptions);
    }
  };

  const handleRuleChange = (selected) => {
    setExtraFields(prev => ({
      ...prev,
      rule: selected
    }));
  };

  const handleStartChange = async (date) => {
    setStartDate(date);
    if (!endDate || endDate <= date) {
      setEndDate(new Date(date.getTime() + 4 * 60 * 60 * 1000));
    }
    if (extraFields.college.length > 0 && (state?.testName || testFormData.test_name)) {
      const collegeLabel = extraFields.college[0]?.label || extraFields.college[0]?.value || '';
      let collegeCode = collegeCodesMap[collegeLabel];
      if (!collegeCode) {
        collegeCode = await fetchCollegeCode(collegeLabel);
        setCollegeCodesMap((prev) => ({ ...prev, [collegeLabel]: collegeCode }));
      }
      const originalTestName = state?.testName || testFormData.test_name;
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const datePart = `${day}${month}`;
      const newTestName = `${collegeCode}_${originalTestName}_${datePart}`;
      setTestFormData(prev => ({
        ...prev,
        test_name: newTestName
      }));
    }
  };

  const handleEndChange = (date) => {
    setEndDate(date);
  };

  useEffect(() => {
    if (state?.time) {
      const durationInt = parseInt(state.time.replace(/\D/g, ''), 10);
      setExtraFields(prev => ({
        ...prev,
        duration: isNaN(durationInt) ? '' : durationInt.toString(),
      }));
    }
    if (Array.isArray(state?.question_ids)) {
      setExtraFields(prev => ({
        ...prev,
        no_of_questions: state.question_ids.length.toString(),
      }));
    }
    if (state?.college && state.college.length > 0) {
      const collegeFromNav = state.college[0];
      const collegeName = collegeFromNav?.label || collegeFromNav?.value || '';
      const updateCodeAndName = async () => {
        let code = await fetchCollegeCode(collegeName);
        setCollegeCodesMap((prev) => ({ ...prev, [collegeName]: code }));
        if (collegeName && state.testName && startDate) {
          const day = String(startDate.getDate()).padStart(2, '0');
          const month = String(startDate.getMonth() + 1).padStart(2, '0');
          const datePart = `${day}${month}`;
          const newTestName = `${code}_${state.testName}_${datePart}`;
          setTestFormData(prev => ({
            ...prev,
            test_name: newTestName
          }));
          setExtraFields(prev => ({
            ...prev,
            college: state.college
          }));
        }
      };
      updateCodeAndName();
    }
  }, [state, startDate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
 if (isSubmitting) return; // ⛔ Prevent multiple clicks

    setIsSubmitting(true);
    try {
      const college_id = extraFields.college.map(c => c.value);
      const filteredDepartments = selectedDepartments.filter(department => department.value !== 'all');
      const department_id = filteredDepartments?.map(department => department.value) || [];
      const batch_no = extraFields.branch.map(b => b.value);
      const year = selectedYear?.map(y => y.value) || [];
      const rules_id = extraFields.rule ? extraFields.rule.value : null;

      const payload = {
        test_name: testFormData.test_name,
        test_type: state?.test_type || '',
        skill_type: state?.sub_topic || '',
        question_type: state?.topic || '',
        folder_name: state?.folder_name || '',

        created_by: 'System',
        question_ids: state?.question_ids || [],
        is_testcase: state?.is_testcase || false,
        college_id,
        batch_no,
        department_id,
        dtm_start: formatDateTime(startDate),
        dtm_end: formatDateTime(endDate),
        is_camera_on: extraFields.is_camera_on,
        duration_type: "QuestionTime",
        year,
        rules_id,
        need_candidate_info: extraFields.need_candidate_info,
        duration: extraFields.duration,
        no_of_question: extraFields.no_of_questions,
        
      };

      // Send data using your existing API function
      await sendAssignTestData_API_superadmin(payload);

      alert('Test data sent successfully!');
      navigate('/test/test-schedules/');
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        alert(error.response.data.error);
      } else {
        alert('Failed to send test data.');
      }
       setIsSubmitting(false);
    }
   
  };

  const rowStyle = { display: 'flex', gap: '24px', marginBottom: '18px' };
  const colStyle = { flex: 1, display: 'flex', flexDirection: 'column' };
  const labelStyle = { color: 'white', marginBottom: '4px' };
  const inputStyle = {
    width: '100%',
    background: '#323b44',
    color: 'white',
    border: '1px solid #555',
    borderRadius: '4px',
    padding: '5px'
  };

  return (
    <div style={{ marginTop: '1px' }}>
      <form
        style={{
          background: '#323b44',
          padding: '30px',
          borderRadius: '8px',
          minWidth: '400px',
          minHeight: '400px',
          width: 'auto',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
        onSubmit={handleSubmit}
      >
        <h3 style={{ color: 'white' }}>Add Test</h3>

        {/* Row 1: Test Name, Duration */}
        <div style={rowStyle}>
          <div style={colStyle}>
            <label style={labelStyle}>Test Name:</label>
            <input
              type="text"
              name="test_name"
              value={testFormData.test_name}
              onChange={handleInputChange}
              style={inputStyle}
              required
            />
          </div>
          <div style={colStyle}>
            <label style={labelStyle}>Duration of Test (minutes):</label>
            <input
              type="number"
              name="duration"
              value={extraFields.duration}
              onChange={handleExtraChange}
              style={inputStyle}
              min="1"
            />
          </div>
        </div>

        {/* Row 2: No of Questions, College Name */}
        <div style={rowStyle}>
          <div style={colStyle}>
            <label style={labelStyle}>No of Questions:</label>
            <input
              type="number"
              name="no_of_questions"
              value={extraFields.no_of_questions}
              onChange={handleExtraChange}
              style={inputStyle}
              min="1"
            />
          </div>
          <div style={colStyle}>
            <label style={labelStyle}>College Name:</label>
           <Select
  isMulti
  name="college"
  value={extraFields.college}
  onChange={handleSelectChange}
  options={userColleges}
  components={{ Option: CustomOption }}
     closeMenuOnSelect={false}
  isDisabled={userRole === "Placement Officer"}  // 👈 Disables for PO
styles={customStyles}
  placeholder={userRole === "Placement Officer" ? "Auto-selected for Placement Officer" : "Select College(s)"}
/>

          </div>
        </div>

        {/* Row 3: Branch (conditionally rendered), Department */}
        <div style={rowStyle}>
          {branchList.length > 0 && (
            <div style={colStyle}>
              <label style={labelStyle}>Branch:</label>
              <Select
                isMulti
                name="branch"
                value={extraFields.branch}
                onChange={handleSelectChange}
                options={branchList}
                isDisabled={!branchList.length}
                components={{ Option: CustomOption }}
               closeMenuOnSelect={false}
               styles={customStyles}
                placeholder="Select Branch(es)"
              />
            </div>
          )}
          <div style={colStyle}>
            <label style={labelStyle}>Department:</label>
            <Select
              isMulti
              name="department"
              value={selectedDepartments}
              onChange={handleDepartmentsChange}
              options={departmentList}
              isDisabled={!departmentList.length}
              components={{ Option: CustomOption }}
              closeMenuOnSelect={false}
              styles={customStyles}
              placeholder="Select Department(s)"
            />
          </div>
        </div>

        {/* Row 4: Year, Rule */}
        <div style={rowStyle}>
          <div style={colStyle}>
            <label style={labelStyle}>Year:</label>
            <Select
              isMulti
              name="year"
              value={selectedYear}
              onChange={handleYearChange}
              options={yearOptions}
             components={{ Option: CustomOption }}
                 closeMenuOnSelect={false}
              placeholder="Select Year(s)"
              styles={customStyles}
            />
          </div>
          <div style={colStyle}>
            <label style={labelStyle}>Rule:</label>
            <Select
              name="rule"
              value={extraFields.rule}
              onChange={handleRuleChange}
              options={ruleList}
             styles={customStyles}
              placeholder="Select Rule"
            />
          </div>
        </div>

        {/* Row 5: Start/End Date, Camera, Candidate Info */}
        <div style={rowStyle}>
          <div style={colStyle}>
            <label style={labelStyle}>Start Date & Time:</label>
            <DatePicker
              selected={startDate}
              onChange={handleStartChange}
              showTimeSelect
              timeFormat="hh:mm aa"
              timeIntervals={15}
              dateFormat="dd-MM-yyyy, h:mm aa"
              timeCaption="Time"
              customInput={<CalendarInput />}
            />
          </div>
          <div style={colStyle}>
            <label style={labelStyle}>End Date & Time:</label>
            <DatePicker
              selected={endDate}
              onChange={handleEndChange}
              showTimeSelect
              timeFormat="hh:mm aa"
              timeIntervals={15}
              dateFormat="dd-MM-yyyy, h:mm aa"
              timeCaption="Time"
              customInput={<CalendarInput />}
              minDate={startDate}
            />
          </div>
        </div>

        {/* Row 6: Camera, Candidate Info, Testcase Checkbox */}
        <div style={rowStyle}>
         {/*} <div style={colStyle}>
            <label style={labelStyle}>
              <input
                type="checkbox"
                name="is_camera_on"
                checked={extraFields.is_camera_on}
                onChange={handleExtraChange}
                style={{ marginRight: '8px' }}
              />
              Camera On
            </label>
          </div>*/}
          <div style={colStyle}>
            <label style={labelStyle}>
              <input
                type="checkbox"
                name="need_candidate_info"
                checked={extraFields.need_candidate_info}
                onChange={handleExtraChange}
                style={{ marginRight: '8px' }}
              />
              Need Candidate Info
            </label>
          </div>
          {testFormData.test_type === 'Coding Test' && (
            <div style={{ marginBottom: '16px' }}>
              <label style={labelStyle}>
                <input
                  type="checkbox"
                  checked={isTestcase}
                  onChange={handleTestcaseChange}
                  style={{ marginRight: '8px' }}
                />
                Is Testcase
              </label>
            </div>
          )}
        </div>

        {/* Bottom buttons */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: '30px'
        }}>
          <button
            type="button"
            onClick={() => navigate(-1)}
            style={{
              background: '#f1a128',
              color: 'black',
              border: 'none',
              padding: '8px 24px',
              borderRadius: '4px',
              fontWeight: 'bold',
              cursor: 'pointer'
            }}
          >
            Back
          </button>
          <button
      type="submit"
      onClick={handleSubmit}
      disabled={isSubmitting} // 🔒 Prevent multiple clicks
      style={{
        background: isSubmitting ? '#ccc' : '#f1a128',
        color: 'black',
        border: 'none',
        padding: '8px 24px',
        borderRadius: '4px',
        fontWeight: 'bold',
        cursor: isSubmitting ? 'not-allowed' : 'pointer',
      }}
    >
      {isSubmitting ? 'Submitting...' : 'Submit'}
    </button>
        </div>
      </form>
    </div>
  );
};

export default AddTestPage;
